import { Modal, Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import { useEffect } from "react";

export const ImagePreviewModal = ({ open, onClose, imageUrl, imageName }) => {
  // Cerrar con la tecla ESC
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    if (open) {
      document.addEventListener("keydown", handleKeyDown);
      // Prevenir scroll del body cuando el modal está abierto
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "unset";
    };
  }, [open, onClose]);

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = imageUrl;
    link.download = imageName || "image.png";
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(4px)",
      }}
    >
      <Box
        sx={{
          position: "relative",
          maxWidth: "90vw",
          maxHeight: "90vh",
          outline: "none",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Barra de herramientas */}
        <Box
          sx={{
            position: "absolute",
            top: -60,
            right: 60,
            display: "flex",
            gap: 1,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            borderRadius: 2,
            padding: 1,
          }}
        >
          {/* Nombre del archivo */}
          <Typography
            variant="body2"
            sx={{
              color: "white",
              alignSelf: "center",
              px: 2,
              maxWidth: 300,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {imageName}
          </Typography>

          {/* Botón de descarga */}
          <IconButton
            onClick={handleDownload}
            sx={{
              color: "white",
              "&:hover": {
                backgroundColor: "rgba(var(--fx-surface-basergb, 255, 255, 255), 0.1)",
              },
            }}
            size="small"
          >
            <DownloadIcon />
          </IconButton>

          {/* Botón de cerrar */}
          <IconButton
            onClick={onClose}
            sx={{
              color: "white",
              "&:hover": {
                backgroundColor: "rgba(var(--fx-surface-basergb, 255, 255, 255), 0.1)",
              },
            }}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Imagen */}
        <Box
          component="img"
          src={imageUrl}
          alt={imageName}
          sx={{
            maxWidth: "100%",
            maxHeight: "60vh",
            objectFit: "contain",
            borderRadius: 2,
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
            backgroundColor: "var(--fx-surface-base, #FFFFFF)",
          }}
          onClick={onClose}
        />

        {/* Indicador de click para cerrar */}
        <Typography
          variant="caption"
          sx={{
            position: "absolute",
            bottom: -40,
            color: "white",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            px: 2,
            py: 0.5,
            borderRadius: 1,
            opacity: 0.8,
          }}
        >
          Haz clic en la imagen o presiona ESC para cerrar
        </Typography>
      </Box>
    </Modal>
  );
};
